export const ROUTE_PATHS = {
  ROOT: '',

  AUTH: 'auth',
  LOGIN: 'auth/login',
  AUTH_CALLBACK: 'auth/callback',
  FORGOT_PASSWORD: 'auth/forgot-password',
  RESET_PASSWORD: 'auth/reset-password',
  CHANGE_PASSWORD: 'auth/change-password',

  DASHBOARD: 'dashboard',

  USERS: 'users',
  USERS_DETAIL: 'users/:id',
  USERS_EDIT: 'users/:id/edit',

  ORGANIZATIONS: 'organizations',
  ORGANIZATIONS_CREATE: 'organizations/create',
  ORGANIZATIONS_DETAIL: 'organizations/:id',
  ORGANIZATIONS_EDIT: 'organizations/:id/edit',
  IDENTITY_PROVIDERS: 'identity-providers',
  IDENTITY_PROVIDERS_CREATE: 'identity-providers/create',
  IDENTITY_PROVIDERS_DETAIL: 'identity-providers/:id',
  IDENTITY_PROVIDERS_EDIT: 'identity-providers/:id/edit',

  OAUTH_CLIENTS: 'oauth-clients',
  OAUTH_CLIENTS_DETAIL: 'oauth-clients/:id',
  PLATFORM_ACCESS: 'platform-access',
  API_ACCESS: 'api-access',

  ROLES: 'roles',
  ROLES_CREATE: 'roles/create',
  ROLES_DETAIL: 'roles/:id',
  ROLES_EDIT: 'roles/:id/edit',

  SECURITY: 'security/settings',
  SIGNING_KEYS: 'security/signing-keys',

  OIDC_OPERATIONS: 'monitoring/oidc',
  ACTIVITY_LOGS: 'audit/activity-logs',
  ACTIVITY_LOG_DETAIL: 'audit/activity-logs/:id',
  SECURITY_EVENTS: 'audit/security-events',
  SECURITY_EVENT_DETAIL: 'audit/security-events/:id',

  PROFILE: 'profile',
} as const;
